import { RepositoryFiltersController } from './repository-filters.controller'

function repositoryFilters () {
  return {
    restrict: 'E',
    scope: {
      filterParams: '='
    },
    templateUrl: '/repository/directives/repository-filters/repository-filters-directive.html?$$REVISION$$',
    controller: RepositoryFiltersController
  }
}

export { repositoryFilters }
